import React, {useEffect, useRef, useState} from 'react';
import {Button, Col, Input, PageHeader, Popconfirm, Row, Table,} from 'antd';
import {deleteD365HoursCategory, getD365HoursCategories} from "../../api/d365Api";
import {DeleteOutlined, ReloadOutlined, SearchOutlined} from "@ant-design/icons";
import {useUserPermissions} from "../../auth/userHooks";
import {HoursCategoryButton} from "./HoursCategoryButton";
import _ from "lodash";
import {handleResponse} from "./utils";
import {getPaginationConfig} from "../../util/showAllPagination";
import {useDynamicTableHeight} from "../../util/useDynamicTableHeight";

const Hours = () => {
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const permissions = useUserPermissions();
  const tableContainerRef = useRef(null);
  const tableHeight = useDynamicTableHeight(tableContainerRef);
  const columns = [
    {
      title: 'Category Names',
      key: 'ID',
      dataIndex: 'categoryName',
      sorter: (a, b) => a.categoryName.localeCompare(b.categoryName),
      render: i => i ? i : '-'
    },
    {
      title: 'Category Codes',
      dataIndex: 'categoryCode',
      sorter: (a, b) => a.categoryCode.localeCompare(b.categoryCode),
      width: '20%',
      render: i => i ? i : '-'
    },
    {
      title: 'Action',
      key: 'action',
      width: '225px',
      render: h => (
        <>
          {permissions !== null && permissions.canManageHours && (
            <>
              <Row>
                <HoursCategoryButton
                  style={{marginRight: 10, align: "center"}}
                  isEdit={true}
                  title={"Edit"}
                  onCompleted={handleCategoryResponse}
                  categoryID={h.ID}
                  categoryName={h.categoryName}
                  categoryCode={h.categoryCode}
                >
                </HoursCategoryButton>
                <Popconfirm
                  title='Are you sure you want to remove this hours category? (this cannot be undone)?'
                  onConfirm={() => deleteCategory(h.ID, h.categoryName, h.categoryCode)}
                  okText='Yes'
                  cancelText='No'
                >
                  <Button
                    icon={<DeleteOutlined/>}
                  >
                    Delete
                  </Button>
                </Popconfirm>
              </Row>
            </>
          )}
        </>
      ),
    },
  ];


  const filterCategories = (categories, searchText) => {
    var lcSearchText = _.toLower(searchText)
    setFilteredCategories(
      _.chain(categories)
        .filter(
          (u) =>
            searchText === "" ||
            _.includes(_.toLower(u.categoryName), lcSearchText) ||
            _.includes(_.toLower(u.categoryCode), lcSearchText)
        )
        .value()
    );
  }

  const search = (text) => {
    filterCategories(categories, text);
  };

  const loadCategories = async () => {
    try {
      setLoading(true);
      const categories = await getD365HoursCategories();
      setCategories(categories);
      filterCategories(categories)
    } catch (e) {
      console.error(`Could not get hours codes`);
    } finally {
      setLoading(false);
    }
  }

  const deleteCategory = (ID, categoryName, categoryCode) => {
    setLoading(true);
    deleteD365HoursCategory(ID, categoryName, categoryCode).then(response => {
      handleCategoryResponse(response, 'delete')
    }).finally(() => {
      setLoading(false);
    });
  };

  const handleCategoryResponse = (response, action) => {
    handleResponse(response, "Category", action)
    loadCategories();
  };


  useEffect(() => {
    loadCategories();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Row>
        <Col span={12}>
          <PageHeader
            title="Hours Categories"
            subTitle={`(${filteredCategories.length} shown)`}
            style={{padding: 0}}
          />
        </Col>
      </Row>

      <Row style={{marginBottom: 10}}>
        <Col span={12} style={{marginRight: 10}}>
          <Input
            style={{maxWidth: 400}}
            placeholder="Search for categories by name"
            prefix={<SearchOutlined/>}
            onChange={(e) => search(e.target.value)}
            allowClear
          />
        </Col>

        <Col flex="auto">
          {permissions !== null && permissions.canManageHours && (
            <>
              <Button
                style={{float: 'right'}}
                onClick={() => {
                  loadCategories()
                }}
                loading={loading}
                icon={<ReloadOutlined/>}
              >
                Refresh
              </Button>
              <HoursCategoryButton
                disabled={loading}
                isEdit={false}
                title={"Create Category"}
                onCompleted={handleCategoryResponse}
                style={{float: 'right', marginRight: 10}}
              >
              </HoursCategoryButton>
            </>
          )}
        </Col>
      </Row>

      <Table
        ref={tableContainerRef}
        rowKey="ID"
        dataSource={filteredCategories}
        columns={columns}
        pagination={getPaginationConfig(filteredCategories.length)}
        size="small"
        loading={loading}
        scroll= {{y: tableHeight}}
      />
    </>
  );
};

export {Hours};
